import React , { useState , useEffect, useMemo  } from "react";
import useAuth from '../../../hooks/useAuth';
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import Loader from '../../../components/Loader/Loader';
import TrainingService from '../../../services/TrainingService';
import shareIcon from '../../../assets/images/share-icon.png';
import downloadIcon from '../../../assets/images/download-icon.png';
import CommonShareModal from "../../../components/Modals/CommonShareModal";

const InformationStationTab = ( { active }) => {
    const { user } = useAuth();
    const [showLoader, setShowLoader] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showShareMessageModal, setShowShareMessageModal] = useState(false);
    const [data , setData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showSpinner ,setShowSpinner] = useState(false);
    
    const trainingService = useMemo(() => new TrainingService(), []);

    useEffect(() => {
        trainingService.getInformationStations({ portal_user_id: user.id }).then((response) => {
            const dataResponse = response.data;

            if (dataResponse.status === 'success') {
                if (dataResponse.result.length > 0) {
                    setData(dataResponse.result);
                }
            }

        }).finally(() => {
            setShowLoader(false);
        });

    },[active, user, trainingService]);
    
    if (!active) return null;

    const renderNoData = () => {
        return (
            <div className="text-center my-5 fade-in">
                <div className="p-5 rounded-3 shadow-sm bg-light border mx-5">
                    <h3 className="fw-bold text-dark">Data not found.</h3>
                </div>
            </div>
        )
    }

    const handleDownload = async (url, filename) => {
        try {
            setShowSpinner(true);

            const response = await trainingService.downloadFile(url);

            // 🔹 Get filename from header
            let fileName = 'file'; // fallback

            const contentDisposition = response.headers['content-disposition'];

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            // 🔹 Create blob
            const blob = new Blob([response.data]);

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = downloadUrl;
            link.download = fileName; // ✅ original filename

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            console.error('Download failed', error);
        } finally {
            setShowSpinner(false);
        }
    };

    const handleShareClick = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const handleShareSubmit = async (formData) => {
        try {
            const payLoads = {
                email: formData.email,
                selected_id: selectedItem?.id,
                portal_user_id: user.id
            };
            trainingService.shareInformation(payLoads).then((response) => {
                const data = response.data;
                if(data.status === 'success') {
                    setSuccessMessage(data.message);
                } else {
                    setErrorMessage(data.message);
                }
            });
            setShowShareMessageModal(true);
            setShowModal(false);
            setTimeout(() => {
    			setShowShareMessageModal(false);
    			setSuccessMessage('');
    			setErrorMessage('');
    		},2000);

        } catch (error) {
            console.error(error);
        }
    };

    const renderInformationData = () => {
        if (showLoader) {
            return <GearSpinner />;
        }

        if (!data || data.length === 0) {
            return renderNoData();
        }

        return (
            <React.Fragment>
                {data.map((value, index) => (
                    <div key={index} className="col-md-4 col-sm-4 col-lg-3 col-xl-3 col-6">
                        <div className="guidesBox">
                            <div className="guides-img">
                                <a href={value.file_url} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={value.thumbnail_url}
                                        alt={value.title}
                                        className="img-fluid d-block"
                                    />
                                </a>
                            </div>
                            <h4>{value.title}</h4>
                        </div>

                        <div className="guides-img-footer">
                            <div className="row">
                                <div className="col-6">
                                    <button
                                        onClick={() => handleDownload(value.file_url, value.title)}
                                        className="btn-link-style p-0"
                                    >
                                        <img src={downloadIcon} className="img-fluid d-block" alt="Download" />
                                        <h6>Download</h6>
                                    </button>
                                </div>

                                <div className="col-6">
                                    <button
                                        className="btn-link-style"
                                        onClick={() => handleShareClick(value)}
                                    >
                                        <img src={shareIcon} className="img-fluid d-block" alt="Share" />
                                        <h6>Share</h6>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        );
    };


    return (
        <React.Fragment>
            <div className="row tab-scroll">
                <div className="col-md-12">
                    <h5>Information Station</h5>
                    <div className="row mt-5">														
                        <div className="col-md-12">
                            <div className="row g-3">
                                {renderInformationData()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CommonShareModal 
                isShow={showModal} 
                onClose={() => setShowModal(false)} 
                onShare={handleShareSubmit} 
                showShareMessageModal={showShareMessageModal}
                onCloseShareMessage={() => setShowShareMessageModal(false)} 
                successMessage={successMessage} 
                errorMessage={errorMessage} 
            />
            <Loader message="Processing..." isLoading={showSpinner} />
        </React.Fragment>
    );
};

export default InformationStationTab;